// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mobileLinks":"footer__mobileLinks__1Mlc3","textLink":"footer__textLink__2SV1Y","app":"footer__app__1r2PY"};